import React, {useState, useEffect} from 'react'
import './style.css'
import axios from 'axios'
import Error from '../Component/Error';
import Footer from './Footer';
import { FaCloudDownloadAlt, FaSignInAlt } from "react-icons/fa";
import Certif from '../assets/Certificate.svg'
import SLoader from '../Component/Loading/SigninLoader';
import Confirm from '../Component/Confirm';
import Navbar from '../Component/Navbar';
import { useNavigate } from "react-router-dom";

const Userpage = () => {
    const [emailval, setEmailval] = useState("");
    const [testIdval, setTestIdval] = useState("");
    const [downloadUrl, setDownloadUrl] = useState([]);
    const [overlaylog, setOverlaylog] = useState(0)
    const [confiemres, setConfirmres] = useState(false)
    const [loading, setLoading] = useState(false)
    const [currentState, setCurrentState] = useState("")
    let navigate = useNavigate();

    useEffect(()=>{
        setCurrentState("1");
    },[])

    const handleSubmit = async (e)  =>{
      try{
          setLoading(true)
          e.preventDefault()
          let Objs = {
              email: emailval,
              studentID: testIdval
          }

          await axios.post(`https://sabre-ng-e-certificate.herokuapp.com/getCertificates`, Objs).then((response) => {
            if(response.status === 201){
                console.log(response.data)

                if(JSON.stringify(response.data).includes("certificates")){
                  setDownloadUrl(response.data.certificates.map((itemm) => (itemm.certificateURL)))
                  // console.log(`i'm not empty :${downloadUrl}`);
                  setConfirmres(true)
                  setOverlaylog(1)
                }
                // else if(JSON.stringify(response.data).includes("paymentUrl")){
                //   setPaymenturl(response.data.paymentUrl)
                //   window.open(paymenturl, "_self")
                //   // console.log(`Payment url: ${paymenturl}`)
                // }

                clearfields();
                setLoading(false)
              }
              else{
                // console.log('error')
              }
          });

        }
        catch(error){
          // console.log('New error')
          setLoading(false)
          setOverlaylog(2)
        }
    }

    const clearfields = () =>{
      setEmailval("");
      setTestIdval("");
    }

    const handleChanges = (e) =>{
      if(e.target.name === "email"){
        setEmailval(e.target.value)
      }
      if(e.target.name === "testid"){
        setTestIdval(e.target.value)
      }
    }

    const handleClose = (closeStatus) =>{
        setOverlaylog(closeStatus)
    }

    const handleCertClick = () =>{
      window.open(downloadUrl, "_blank")
      setConfirmres(false)
    }

    const clickState = (currentClickState) =>{
      // console.log(`clicked: ${currentClickState}`)
      navigate("/login", { replace: false });
    }

  return (
    <div className='mainContain'>
      <Navbar loginClick={clickState} defaultState={currentState} />
      {loading ? <SLoader /> :
        <div className='bodyContiner'>
          <div className='iconContainer'><img src={Certif} alt="iconImage"  id='certificateIcon'/></div>
          <div className='iconContainer2'><span id="heading">Sabre E-Certificate Generation Portal</span></div>
          <form id="submitForm" onSubmit={handleSubmit}>
              <input onChange={handleChanges} name="email" value={emailval} type="email" placeholder="Enter Your Email Address" id="inputField" />
              <input onChange={handleChanges} name="testid" value={testIdval} type="text" placeholder="Enter Your Test ID" id="inputField" />
              <div className='buttnContainer'>
                <span id='submitContainer'>
                  <input value="VERIFY" type="submit" id="submitButn"/><FaSignInAlt id="submitIcon"/>
                </span>
                <span id='submitContainer'>
                  {confiemres ? <button id="submitButn_" onClick={handleCertClick}>DOWNLOAD</button> : <button id="submitButn_" disabled>DOWNLOAD</button>}
                  <FaCloudDownloadAlt id="submitIcon2" />
                </span>
              </div>
          </form>
      </div>}
      <div className="mainfootContain">
        <Footer />
      </div>
      {overlaylog === 1 ? <Confirm closeOverlay={handleClose} message="Email Verified!. Download Now!"/> : overlaylog === 2 ? <Error closeOverlay={handleClose} message="Email or ID Not Registerd!"/> : "" }
    </div>
  )
}

export default Userpage